// src/hoc/withPreviewRoot.js
import React, { useState, useEffect } from "react";
import PreviewRoot from "../Component/Preview/index";

export const withPreviewRoot = (WrappedComponent) => {
  return (props) => {
    const [showPreview, setShowPreview] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(
      typeof window !== "undefined" ? window.innerWidth < 1024 : false
    );

    useEffect(() => {
      const handleResize = () => setIsSmallScreen(window.innerWidth < 1024);
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const togglePreview = () => setShowPreview((prev) => !prev);

    // On small screens, only one pane is visible at a time.
    // We use CSS display to hide — NEVER unmount — so component state is preserved.
    const wrappedHiddenOnSmall = isSmallScreen && showPreview;
    const previewHidden = !showPreview;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: "calc(100vh - 100px)",
          gap: "16px",
        }}
      >
        {/* Header with toggle button */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px 16px 0",
          }}
        >
          <button
            onClick={togglePreview}
            style={{
              padding: "8px 20px",
              borderRadius: "8px",
              border: "1px solid #3b82f6",
              background: showPreview ? "#f1f5f9" : "#3b82f6",
              color: showPreview ? "#1e293b" : "#ffffff",
              fontWeight: 600,
              fontSize: "14px",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            {showPreview ? "Hide Preview Panel" : "Show Preview Panel"}
          </button>
        </div>

        {/* Split area — BOTH panes always mounted; visibility via display */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            flex: 1,
            overflow: "hidden",
          }}
        >
          {/* Wrapped component — always mounted */}
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              paddingRight: isSmallScreen ? "0" : "10px",
              // Hide it visually on small screens when preview is open — but keep it mounted
              display: wrappedHiddenOnSmall ? "none" : "block",
            }}
          >
            <WrappedComponent {...props} />
          </div>

          {/* Preview panel — always mounted; visibility via display */}
          <div
            className="prevWrap"
            style={{
              flex: isSmallScreen ? 1 : "0 0 auto",
              width: isSmallScreen ? "100%" : undefined,
              display: previewHidden ? "none" : "block",
            }}
          >
            <PreviewRoot appData={props.appData} />
          </div>
        </div>
      </div>
    );
  };
};